import { lazy } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import type { AppletDefinition } from '../../applets';
import StudioShellLayout from '../StudioShellLayout';

const LazyBatchMascot = lazy(() => import('./components/BatchMascot'));

const applet = {
  id: 'mascot',
  path: '/mascot',
  paths: ['/mascot', '/mascot/:id', '/batch-mascot', '/batch-mascot/:id'],
  label: 'Mascot',
  description: 'Video character replacement',
  dashboard: {
    // Discontinued: retain direct routes and legacy jobs without advertising creation.
    hideFromCreateGrid: true,
    imageSrc:
      'https://resources.getcartwheel.com/share/demo-videos/mascot-thumb.jpg',
    imageAlt: '',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/app_launcher_mascot.webm',
    title: 'Mascot',
    description: 'Video capture to 2D character animation.',
    order: 60,
  },
  policy: {
    requiresLoggedIn: false,
    requiresApiKey: 'soft',
  } satisfies Policy,
  component: LazyBatchMascot,
  layout: StudioShellLayout,
} satisfies AppletDefinition;

export default applet;
